export const LEGAL = {
  appName: "Basta10",
  ownerName: "Dakota Basta",
  supportEmail: "dakota_basta@hotmail.com",
  website: "basta10.com",
  governingLaw: "the United States",
  effectiveDate: "September 12, 2026",
};
